import { connect } from 'react-redux'
import { reduxForm, formValueSelector } from 'redux-form'

import { updateProvider } from '../ProviderActions'
import FormStepTwo from '../components/FormStepTwo'

import { parseValueProvider } from '../../utils/parse'

import { addNotifSuccess, addNotifError } from '../../notification/NotificationActions'

const selector = formValueSelector('FormStepTwoForm');

const mapStateToProps = (state) => {
    
    const {plateau, acf, reseau, bill}  = selector(state, 'plateau', 'acf', 'reseau', 'bill');
    return {
       regions : state.datas.regions,
       user : state.user,
       provider : state.provider.provider,
       initialValues: state.provider.provider.provider,
       getValue: {
            plateau,
            acf,
            reseau,
            bill
       }
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
    }
};

const validate = values => {
  const errors = {};

  if(values.date_company_day && values.date_company_month && values.date_company_year)
  {
    var date = new Date(values.date_company_year,values.date_company_month-1,values.date_company_day);
    var now = new Date();

    if(date > now) {
        errors.date_company_day = "Saisir une date correct";
        errors.date_company_month = true;
        errors.date_company_year = true;
    }
    
  }

  return errors
};

const config = {
    form: 'FormStepTwoForm',
    validate,
    onSubmit: (values, dispatch, props) => {
        window.scrollTo(0, 0);

        const fields = [
            "company", "address", "additional_address", "zip", "city", "legal_form", "day", "date_company_day", "date_company_month", "date_company_year", "siret", "code_provider", "tva",
            "plateau", "plateau_name", "plateau_phone", "plateau_email", "plateau_comment",
            "acf", "acf_name", "acf_phone", "acf_email", "acf_comment",
            "reseau", "reseau_name", "reseau_phone", "reseau_email", "reseau_comment",
            "bill", "bill_name", "bill_phone", "bill_email", "bill_comment", "region"
        ];

        var datas = parseValueProvider(fields, values);
        
        if(datas["date_company_day"] && datas["date_company_month"] && datas["date_company_year"])
        {
            datas["date_company"] = datas["date_company_year"]+"-"+datas["date_company_month"]+"-"+datas["date_company_day"]
        }else{
            delete datas["date_company"]
        }
        
        return dispatch(updateProvider(props.provider.provider.id, datas))
            .then((response) => {
                if(props.create){
                    props.nextPage()
                }else{
                    dispatch(addNotifSuccess("Vos informations sont enregistrées", "Confirmation"))
                }
                
            })
            .catch((error) => {
                dispatch(addNotifError("Erreur", "Veuillez recommencer."))
            })
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(reduxForm(config)(FormStepTwo))



// WEBPACK FOOTER //
// ./src/provider/containers/FormStepTwoContainer.js